export const favouriteGamesSchema = {
  type: 'favourite-games',
  label: 'Favourite Games',
  description: 'Showcase your favourite chess games with interactive replay',
  icon: 'Trophy',
  defaultContent: {
    title: 'My Favourite Games',
    matchThemeSquares: false,
    games: [],
    style: {},
  },
  fields: [
    { name: 'title', label: 'Section Title', type: 'text', placeholder: 'My Favourite Games' },
    { name: 'matchThemeSquares', label: 'Match Theme Color', type: 'checkbox' },
  ],
};
